import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom"; // Import Link
import ProductGroup from "./ProductGroup";
import ProductService from "../services/ProductService";
import { IProduct } from "../types/Product"
import LoadingContent from "./LoadingContent";

// Define the type for the product

const HomeProduct: React.FC = () => {
    const [products, setProducts] = useState<IProduct[]>([]);
    const [error, setError] = useState<string | null>(null);

    // Fetch data from API on component mount
    useEffect(() => {
        setProducts(new Array(10).fill(null));
        const fetchProducts = async () => {
            try {
                let response = await ProductService.fetchTopSelling();
                localStorage.setItem("products", JSON.stringify(response));
                setProducts(response); // Store data in state
            } catch (error) {
                setError("Error fetching data");
            }
        };

        fetchProducts(); // Trigger the fetch function
    }, []); // Empty dependency array means this runs once when the component mounts

    if (error) {
        return <div>{error}</div>;
    }

    return (
        <section className="section top-selling">
            <div
                className="is-size-1 is-centered pb-5 home-sticky-header"
                style={{ textAlign: "center" }}
            >
                Our BestSellers
            </div>
            {/* Pass the products to the ProductGroup component */}
            <ProductGroup products={products} />
            <div className="view-all">
                <Link to="/products" className="primary-button">
                    VIEW ALL
                </Link>
            </div>
        </section>
    );
};

export default HomeProduct;
